<template>
  <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" class="h-[21px] w-[21px] m-0.5 text-gray-500">
    <path d="M7 7l3-3 3 3m0 6l-3 3-3-3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg>
</template>
